import type { schemas } from '@gonfalon/openapi/types';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { getProfileQuery } from './members';

export function initializeProfile({ member }: { member: schemas['Member'] }) {
  getQueryClient().setQueryData(getProfileQuery().queryKey, member);
}
